<template>
  <div class="card mb-3">
    <div class="card-header">
      <h5 class="mb-0">{{ translation_key.key }} <span class="badge text-bg-primary float-end">
        <i class="fas fa-tag me-2"></i>{{ translation_key.tag }}</span>
      </h5>
    </div>
    <div class="list-group list-group-flush">
      <TranslationGroup v-for="[locale, translations] in translation_groups" :key="locale.locale"
        :initial-translations="translations" :locale="locale" :scope="scope" :translation_key="translation_key" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type {FullLocale, PropType, TranslationData, TranslationKey, TranslationScope} from "@/types";
import Translation from "./Translation.vue";
import TranslationGroup from "./TranslationGroup.vue";

export default defineComponent({
  name: "TranslationsEditor",
  components: { TranslationGroup, Translation },
  props: {
    translation_key: {
      type: Object as PropType<TranslationKey>,
      required: true,
    },
    translation_groups: {
      type: Array as PropType<[FullLocale, TranslationData[]][]>,
      required: true,
    },
    scope: {
      type: Object as PropType<TranslationScope>,
      required: true,
    },
  },
});
</script>
